import React from "react";
import { Modal, Form, Input, InputNumber, Select, Button } from "antd";

const TPCheckModal = ({
  open, // changed from visible
  onCancel,
  onFinish,
  form,
  handlePackChange,
  handleDiscountChange,
  PACK_OPTIONS,
  RHYTHM_OPTIONS,
  useNbAligners // <-- Add this prop
}) => {
  return (
    <Modal
      title="Add TPCheck Information"
      open={open} // changed from visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
      >
        <Form.Item
          label="TPCheck Link"
          name="TPCheck"
          rules={[{ required: true, message: "Please input the TPCheck link!" }]}
        >
          <Input placeholder="Enter TPCheck link" />
        </Form.Item>
        {useNbAligners ? (
          <Form.Item
            label="Number of Aligners"
            name="nbAligners"
            rules={[{ required: true, message: "Please input the number of aligners!" }]}
          >
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Number of aligners" />
          </Form.Item>
        ) : (
          <Form.Item
            label="Number of Aligners"
            name="alignersNumber"
            rules={[{ required: true, message: "Please input the number of aligners!" }]}
          >
            <InputNumber min={1} style={{ width: '100%' }} placeholder="Number of aligners" />
          </Form.Item>
        )}
        <Form.Item
          label="Nombre d'étape de l'arcade supérieure"
          name="upperArcadeSteps"
        >
          <InputNumber min={0} style={{ width: '100%' }} placeholder="Nombre d'étapes" />
        </Form.Item>
        <Form.Item
          label="Nombre d'étape de l'arcade inférieure"
          name="lowerArcadeSteps"
        >
          <InputNumber min={0} style={{ width: '100%' }} placeholder="Nombre d'étapes" />
        </Form.Item>
        <Form.Item
          label="Change Rhythm (days)"
          name="changeRhythm"
          rules={[{ required: true, message: "Please select the change rhythm!" }]}
        >
          <Select style={{ width: '100%' }}>
            {RHYTHM_OPTIONS.map(option => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Pack"
          name="pack"
          rules={[{ required: true, message: "Please select a pack!" }]}
        >
          <Select
            placeholder="Select a pack"
            style={{ width: '100%' }}
            onChange={handlePackChange}
          >
            {PACK_OPTIONS.map(option => (
              <Select.Option key={option} value={option}>
                {option}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Base Price"
          name="price"
          rules={[{ required: true, message: "Please input the price!" }]}
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          label="Discount (%)"
          name="discount"
        >
          <InputNumber
            min={0}
            max={100}
            style={{ width: '100%' }}
            onChange={handleDiscountChange}
            formatter={value => `${value}%`}
            parser={value => value.replace('%', '')}
          />
        </Form.Item>
        <Form.Item
          label="Final Price"
          name="finalPrice"
        >
          <InputNumber min={0} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Save
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TPCheckModal; 